import LanguageSwitcher from "./LanguageSwitcher";
import { useGlobalContext } from "../contexts/GlobalContext";
import UserMenu from "./UserMenu";
import { useTranslation } from "react-i18next";
const TopBar = (props) => {
  const { t } = useTranslation();
  const { breadcrumbs, setshowSideMenu } = useGlobalContext();
  return (
    <div className="topbar">
      <div className="d-flex justify-content-between gap-2">
        <div className="d-flex align-items-center gap-3">
          <button
            className="visible-sm menu-btn"
            onClick={() => setshowSideMenu(true)}
          >
            <svg
              width="24"
              height="24"
              viewBox="-0.15 -0.21 0.72 0.72"
              xmlns="http://www.w3.org/2000/svg"
              preserveAspectRatio="xMinYMin"
            >
              <path d="M.03 0h.15a.03.03 0 1 1 0 .06H.03a.03.03 0 1 1 0-.06m.21.24h.15a.03.03 0 0 1 0 .06H.24a.03.03 0 1 1 0-.06M.03.12h.36a.03.03 0 0 1 0 .06H.03a.03.03 0 1 1 0-.06" />
            </svg>
          </button>
          {breadcrumbs?.length > 0 && (
            <div className="breadcrumbs">
              {breadcrumbs?.map((breadcrumb, index) => (
                <p
                  key={"breadcrumbs" + index}
                  className={`mb-0 ${
                    index === breadcrumbs.length - 1 ? "active" : "hidden-sm"
                  }`}
                >
                  <span key={index}>{t(breadcrumb)}</span>
                </p>
              ))}
            </div>
          )}
        </div>
        <div>
          <div className="d-flex justify-content-end gap-2">
            <LanguageSwitcher />
            <UserMenu />
          </div>
        </div>
      </div>
    </div>
  );
};

export default TopBar;
